import React, { useEffect, useState } from "react";
import { Star, MapPin, ChevronRight, Info } from "lucide-react";
import JsonData1 from "../../data/ActualData.json";

import ReactPaginate from "react-paginate";
import ClearIcon from "@mui/icons-material/Clear";
import { Button } from "@mui/material";
import { FaRedo } from "react-icons/fa";
import SingleBarChart from "../../chats/SingleBarChart";
import DrawerPage from "./DrawerPage";
import { Link } from "react-router-dom";
import PlotlyGrapgh from "../../chats/PlotlyGrapgh";
import RadialBarChart from "../../chats/RadialBarChart";

export const AllDetails = ({ dataItem }) => {
  console.log(dataItem);
  const [data, setData] = useState(dataItem);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(10);
  const [segmentType, setSegment] = useState("");
  const filter_by_role = [...new Set(data.map((item) => item.Status))];

  let filteredData = [];
  const search_parameters = ["Particulars"];

  filteredData = data.filter((obj) => {
    return obj;
  });

  function search(filteredData) {
    return filteredData.filter(
      (item) =>
        item.Status.includes(segmentType) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const reset = () => {
    setCurrentPage(1);
    setQuery("");
    setSegment("");
  };
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get("name");
  const details = urlParams.get("details");
  const node = urlParams.get("node");

  console.log(name);
  console.log(details);
  console.log(node);
  console.log(data);

  const totalMargin = data && data
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);

  console.log(totalMargin)
  useEffect(() =>{
    setData(dataItem)
  },[dataItem])
  return (
    <div style={{ padding: "1rem", zoom: ".9" }}>
   
      <div style={{ display: "grid" }}>
        {/* Header - Hidden on mobile */}
        <div
          style={{ background: "#1453A0", color: "white" }}
          className="hidden md:grid md:grid-cols-[2fr,3fr,3fr,2fr,2fr,1fr,1fr,1fr] gap-4 p-4 bg-gray-100 rounded-t-lg text-sm font-medium text-gray-600"
        >
          <div>Particulars</div>
          <div>KeyInsights</div>
          <div>Recommendations</div>
          <div>Value Creation</div>
          <div>Others</div>
          <div>Functions</div>
          <div>Status</div>
          <div></div>
        </div>

        <div style={{ display: "grid", gap: "1rem" }}>
          {currentData &&
            currentData.map((item, index) => (
              <div
                id={`id_${index}`}
                className="flex flex-col md:grid md:grid-cols-[2fr,3fr,3fr,2fr,2fr,1fr,1fr,1fr] gap-4 p-4 border-b border-gray-200 hover:bg-gray-50 bg-white rounded-lg shadow-sm"
              >
                {/* item Info Section */}
                <div className="flex flex-col  mt-4 sm:flex-row gap-4 md:flex-row">
                  <div className="flex-1">
                    <h5 className="font-medium text-gray-900">
                      {item.Particulars}
                    </h5>
                    <p className="text-sm text-gray-500">{item.ModuleName}</p>
                    <div className="mt-1">
                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Segment: {item.segment || "N/A"}</span>
                      </div>

                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Market: {item.segment || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description Section */}
                <div className="pr-4 mt-4 md:mt-0">
                  <p className="text-sm text-gray-600">{item.KeyInsights}</p>
                  {/* <button className="text-blue-600 text-sm hover:underline mt-1">
                    More
                  </button> */}
                </div>

                {/* Average Stay */}
                {/* <div className="flex items-center gap-4 mt-2 md:mt-0">
                  <span className="md:hidden text-sm text-gray-600 w-32">
                    Average Stay:
                  </span>
               
                  <div className="progress-bar-container">
                    <div  title={`Avg day ${(item.AvgDaysAsPerTerms / 35) * 100}`} className="progress-bar">
                      <div
                        className="progress-fill"
                        title={`Avg day ${(item.AvgDaysAsPerTerms / 35) * 100}`}
                        style={{
                          width: `${(item.AvgDaysAsPerTerms / 35) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <span className="text-sm text-gray-600">
                    {item.AvgDaysAsPerTerms}
                  </span>
                </div> */}

                <div className="pr-4 mt-4 md:mt-0">
                  <p className="text-sm text-gray-600">
                    {item.Recommendations}
                  </p>
                  {/* <button className="text-blue-600 text-sm hover:underline mt-1">
                    More
                  </button> */}
                </div>

                {/* Occupancy Rate and Stats */}
                <div className="mt-4 md:mt-0">
                  <div className="flex items-start gap-4">
                    {/* <CircularProgress percentage={((item.TotalValue/totalMargin)*100).toFixed(0) || 0} /> */}
                    <RadialBarChart valueItem={(item.TotalValue).toFixed(2)} percentage={((item.TotalValue/totalMargin)*100).toFixed(0) || 0}/>
                  
                  </div>
                </div>

                <div className="mt-4 md:mt-0">
                  <div className="flex items-start gap-4">
                  
                    <div className="text-sm text-gray-600">
                      {item &&
                        item.OtherDetails &&
                        item.OtherDetails.length !== 0 &&
                        item.OtherDetails.map((detail, index) => (
                          <div key={index}>
                            {detail.name} : {detail.value}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                {/* Locations */}
                <div
                  style={{ display: "grid", alignContent: "baseline" }}
                  className="gap-1 mt-3"
                >
                <div
                  style={{ display: "grid", alignContent: "baseline" }}
                  className="gap-1"
                >
                  {item &&
                    item.Functions &&
                    item.Functions.map((detail, index) => (
                      <div key={index}>
                        <span
                          style={{
                            borderRadius: "7px",
                            background: "#eee",
                            color: "black",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                          className="inline-flex items-center text-xs font-medium bg-gray-100 text-gray-800"
                        >
                          {detail.name}
                        </span>
                      </div>
                    ))}
                </div>

                </div>

                {/* Rating */}
                <div
                  className={`text-sm font-medium mt-4 md:mt-0 ${
                    item.Status === "To be reviewed"
                      ? "text-green-600"
                      : item.Status === "Action initiated"
                      ? "text-blue-600"
                      : "text-yellow-600"
                  }`}
                >
                  {item.Status}
                </div>

                <div className={`text-sm font-medium mt-5 md:mt-0`}>
                  {/* <Link to={`/dashboard?name=${item.CustomerName}`}>Act</Link> */}
                  <a
                    href={`/dashboard?name=${item.ModuleName}&&details=${item.PrimaryType}&&particulars=${item.Particulars}&&node=${item.SecondaryType}`}
                  >
                    Review
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
